import { default as newsData } from '../../translations/src/lib/ru/news';
import { environment as environmentBase } from './environment.base';
import {
  EnvironmentInterface,
  EnvironmentLocalesEnum,
} from './environment.interface';

const defaultLocale =
  environmentBase.defaultLocale ?? EnvironmentLocalesEnum.RU;

export const environment: EnvironmentInterface = {
  ...environmentBase,
  defaultLocale: defaultLocale,
  news: newsData[defaultLocale],
  vendor: {
    name: environmentBase.vendor?.name ?? 'Netcraze',
    legalName: environmentBase.vendor?.legalName ?? 'ООО «Неткрейз»',
    osName: environmentBase.vendor?.osName ?? 'ОС',
    dnsName: environmentBase.vendor?.dnsName ?? 'KeenDNS',
    dnsExample: environmentBase.vendor?.dnsExample ?? 'name.keenetic.pro',
    supportUrl: environmentBase.vendor?.supportUrl ?? 'support.keenetic.ru',
    docsUrl: environmentBase.vendor?.docsUrl ?? 'support.keenetic.ru',
    forumUrl:
      environmentBase.vendor?.forumUrl ??
      'https://forum.keenetic.ru/forum/42-keenetic-rmm/',
  },
};
